

















































import { Component, Prop, Vue } from 'vue-property-decorator';

import Brand from '@/services/Brand';
import { Policy } from '@/common/Policy';
import { PaymentHistory as PH } from '@/common/Payments';

@Component({
	name: 'PaymentHistory',
})
export default class PaymentHistory extends Vue {
	@Prop({ required: false, default: '' }) private className: string;
	@Prop() private policy: Policy;
	@Prop() private getPaymentHistory: PH[];
	private Brand: any = Brand;
	private paginate: string[] = ['paymentHistory'];

	/**
	 * Sort Payment History
	 */
	get paymentHistory() {
		return this.getPaymentHistory.sort((left: PH, right: PH): number => {
			return new Date(right.date).getTime() - new Date(left.date).getTime();
		});
	}
}
